import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect, useState } from 'react';
import { chooseProfileFilter } from "../../helpers/chooseProfileFilter";

function Form() {
    const profileFilter = chooseProfileFilter()

    const hiddenValues = {}

    if (profileFilter.gci_company_id) {
        hiddenValues.gci_company_id = profileFilter.gci_company_id
    }

    const { id } = useParams();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpointSave: `${endpointBackend}gci/agents/save`,
        endpointGetAllCities: `${endpointBackend}gci/cities/getall`,
        endpointGetById: `${endpointBackend}gci/agents/getById`,
        endpointGetAllMaritalStatus: `${endpointBackend}gci/marital-status/getall`,
        endpointGetAllCompanies: `${endpointBackend}gci/companies/getall`,
        urlGoBack: `/gci/agents/list`,
        pathView: `/gci/agents/view`
    }

    const labels = {
        labelTitleAdd: "Novo Representante",
        labelTitleEdit: "Editar Representante",
        labelTitleView: 'Visualizar Representante'
    }

    const getForm = (values) => {

        let form = {
            hiddenValues,
            fields: [
                !profileFilter.gci_company_id ? {
                    name: 'gci_company_id',
                    type: 'select',
                    label: 'Empresa',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllCompanies,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                } : {},
                {
                    name: 'name',
                    type: 'text',
                    label: 'Nome',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'cpf',
                    type: 'CPF',
                    label: 'CPF',
                    validations: {
                        required: true
                    },
                    columnSize: 4
                },
                {
                    name: 'rg',
                    type: 'RG',
                    label: 'RG',
                    validations: {
                        required: false
                    },
                    columnSize: 4
                },
                {
                    name: 'issuer',
                    type: 'text',
                    label: 'Emissor',
                    validations: {
                        required: false
                    },
                    columnSize: 4
                },
                {
                    name: 'nationality',
                    type: 'text',
                    label: 'Nacionalidade',
                    validations: {
                        required: false
                    },
                    columnSize: 6
                },
                {
                    name: 'gci_marital_status_id',
                    type: 'select',
                    label: 'Estado Civil',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllMaritalStatus,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: false
                    },
                    columnSize: 6
                },
                {
                    name: 'profession',
                    type: 'text',
                    label: 'Profissão',
                    validations: {
                        required: false
                    },
                    columnSize: 6
                },
                {
                    name: 'phone',
                    type: 'phone',
                    label: 'Telefone',
                    validations: {
                        required: false
                    },
                    columnSize: 6
                },
                {
                    name: 'email',
                    type: 'email',
                    label: 'Email',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'city_id',
                    type: 'select',
                    label: 'Município',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllCities,
                        label: 'city_name',
                        value: 'city_id',
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'address',
                    type: 'address',
                    label: 'Endereço',
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                    autocomplete: true,
                    hasComplement: true
                },
                {
                    name: 'observation',
                    type: 'textarea',
                    label: 'Observações',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels,
        }

        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            const form = getForm(values);

            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}

export default Form;
